// extracted by mini-css-extract-plugin
module.exports = {"imgFullLabel":"ImgFullLabel_imgFullLabel__dOtBp","imgFullLabel_slider":"ImgFullLabel_imgFullLabel_slider__rfPzx"};